import {
  Box,
  Stack
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AlertTriangle, CircleCheck, TriangleAlertIcon, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  DescriptionTypography,
  TitleTypography
} from "./CalendarCard.style";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { Spinner } from "../../components/Spinner";
import { useSlotsDeleteQuery } from "../../queries/smartLearning";

export function SmartLearningModalDeleteContent({
  onClose,
  slotId
}: {
    onClose?: () => void
    slotId: number
}) {

  const {
    mutate: deleteSlot,
    isError,
    isIdle,
    isPending: isLoading
  } = useSlotsDeleteQuery();

  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      { isIdle ?
        <Stack
          gap={ "24px" }
        >
          <Stack
            gap={ "32px" }
            sx={ {
              "& .icon": {
                alignSelf: "flex-end"
              }
            } }
          >
            <Stack
              gap={ "1rem" }
              justifyContent={ "center" }
              alignItems={ "center" }
            >
              <TriangleAlertIcon 
                size={ "2rem" }
              />
              <TitleTypography id="title-to-announce-delete">
                { t("slot_question_delete") }
              </TitleTypography>
              <DescriptionTypography>
                { t("slot_warning_delete") }
              </DescriptionTypography>
            </Stack>
            <Stack
              direction={ "row" }
              gap={ "16px" }
              justifyContent={ "center" }
            > 
              <ButtonDigited typology="secondary" onClick={ onClose } text={ t("annul") }/>
              <ButtonDigited 
                typology="primary" 
                onClick={ ()=> {
                  deleteSlot({ slotId: slotId });
                } }
                text={ t("delete")  }
              />
            </Stack>
          </Stack>
        </Stack> :
        <Stack
          role="dialog"
          aria-modal="true"
          aria-labelledby="title-to-announce-delete"
          gap={ "24px" }
        >
          <Stack
            sx={ {
              "& .icon": {
                alignSelf: "flex-end"
              }
            } }
          >
            { /* close modal button */ }
            <Stack
              id="close-modal-icon"
              className="icon"
              tabIndex={ 0 }
              role="button"
              aria-label={ t("close") }
              onClick={ ()=> {if(onClose){onClose()}} }
              onKeyDown={ (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  if(onClose){
                    onClose();
                  }
                }
              } }
              sx={ {
                cursor: "pointer"
              } }
            >
              <X
                type="button"
                size={ "1.5rem" }
                aria-hidden="true"
                color={ theme.customColors.exploreCardText }
                onClick={ ()=> {if(onClose){onClose()}} }
                onKeyDown={ (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    if(onClose){
                      onClose();
                    }
                  }
                } }
              />
            </Stack>
            <Stack
              flexDirection={ "column" }
              justifyContent={ "center" }
              alignItems={ "center" }
              gap={ "1rem" }
            >
              { isLoading ? (
                <>
                  { /* nome accessibile del dialog durante il caricamento (visivamente nascosto) */ }
                  <Box
                    id="title-to-announce-delete"
                    sx={ {
                      border: 0,
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: 0,
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px"
                    } }
                  >
                    { t("loading") }
                  </Box>
                  <Spinner
                    size={ 200 }
                    thickness={ 3 }
                    aria-hidden="true"
                  />
                </> )
                : isError ? (
                  <>
                    <AlertTriangle
                      size={ "3rem" }
                      aria-hidden="true"
                      color={ theme.customColors.exploreCardText }
                    />
                    <TitleTypography id="title-to-announce-delete">
                      { t("error_message") }
                    </TitleTypography>
                  </>
                ) : (
                  <>
                    <CircleCheck
                      size={ "3rem" }
                      aria-hidden="true"
                      color={ theme.customColors.exploreCardText }
                    />
                    <TitleTypography id="title-to-announce-delete" color={ theme.customColors.exploreCardText }>
                      { t("slot_deleted") }
                    </TitleTypography>
                  </>
                )
              }
            </Stack>
          </Stack>

        </Stack>

      }
    </>
  );
}
